var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _vm.siteSelectShow
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "專區",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "siteId"
                              }
                            },
                            [
                              _c(
                                "a-select",
                                {
                                  attrs: { allowClear: "" },
                                  on: { change: _vm.siteChange },
                                  model: {
                                    value: _vm.model.siteId,
                                    callback: function($$v) {
                                      _vm.$set(_vm.model, "siteId", $$v)
                                    },
                                    expression: "model.siteId"
                                  }
                                },
                                _vm._l(_vm.siteList, function(item, index) {
                                  return _c(
                                    "a-select-option",
                                    {
                                      key: index,
                                      attrs: {
                                        value: item.id,
                                        label: item.text
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.siteName) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "栏目編碼",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "自動生成", disabled: "" },
                            model: {
                              value: _vm.model.colCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colCode", $$v)
                              },
                              expression: "model.colCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "栏目名称",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colName"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入栏目名称" },
                            model: {
                              value: _vm.model.colName,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colName", $$v)
                              },
                              expression: "model.colName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "欄目圖片",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colImg"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: "上傳",
                              "upload-source": "hhemp",
                              disabled: _vm.formDisabled
                            },
                            model: {
                              value: _vm.model.colImg,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colImg", $$v)
                              },
                              expression: "model.colImg"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "排序",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "sortNo"
                          }
                        },
                        [
                          _c("a-input-number", {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请输入排序" },
                            model: {
                              value: _vm.model.sortNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "sortNo", $$v)
                              },
                              expression: "model.sortNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "栏目模板",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colType"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              dictCode: "empzone_col_colType",
                              "allow-clear": ""
                            },
                            model: {
                              value: _vm.model.colType,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colType", $$v)
                              },
                              expression: "model.colType"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "栏目链接",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colUrl"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入栏目链接" },
                            model: {
                              value: _vm.model.colUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colUrl", $$v)
                              },
                              expression: "model.colUrl"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "状态",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "status"
                          }
                        },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              type: "radio",
                              dictCode: "empzone_col_status",
                              "allow-clear": ""
                            },
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "栏目介绍",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "colDesc"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: { placeholder: "请输入栏目介绍" },
                            model: {
                              value: _vm.model.colDesc,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "colDesc", $$v)
                              },
                              expression: "model.colDesc"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }